module.exports = __webpack_public_path__ + "img/ennetix-service-page-activity-log.02ef779a.png";